module.exports = __webpack_public_path__ + "img/transparency.8d586f92.svg";